import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { ApiAction, createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getData } from 'modules/activityLog/details/CesTestLogDetails/api/cesTestLogDetailsService'
import { CesTestLogDetailsState, ApiCesTestLogDetailsResponse } from './types'

const initialState: CesTestLogDetailsState = {
  data: {},
}

const cesTestLogDetailsSlice = createSlice({
  name: 'activityLogCesTestLogDetails',
  initialState,
  reducers: {
    dataLoaded(state, action: PayloadAction<ApiMiddlewarePayload<ApiCesTestLogDetailsResponse>>) {
      state.data = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { dataLoaded } = cesTestLogDetailsSlice.actions

export default cesTestLogDetailsSlice.reducer

export const loadData = (): ApiAction => {
  return createApiAction({
    apiCalls: {
      info: getData,
    },
    payloadAction: dataLoaded,
  })
}
